import Image from 'next/image'

export default function SitSpotIcon( { complete } ) {
  // const { bg, fg1, fg2 } = getIconColors( complete )
  
  return (
    <Image width={ 100 } height={ 100 } sizes="100vw" style={ { width: '100%', aspectRatio: '1' } } src={ complete ? '/images/icons/sit-spot-colour.png' : '/images/icons/sit-spot-grey.png' } alt="Sit spot icon" />  
  )
}
